import { AgGridReact } from 'ag-grid-react';
import { useRef } from 'react';
import Header from '../../common/Header/Header';
import { Page, TableWrapper } from '../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles';
import Table from '../../components/Table/Table';
import { useProductGroupDetails } from '../../services/productGroupDetail/productGroupDetail.service';
import { useFetchErrorToast } from '../../utils/useFetchErrorToasts/useFetchErrorToast';

const ProductGroupDetails = () => {
    const gridRef = useRef<AgGridReact>(null);
    const {data, isError} = useProductGroupDetails();
    useFetchErrorToast([{isError, label: 'Error fetching Product Group Details', id: 'productGroupDetailFetchError'}]);
    return (
        <>
            <Header breadcrumb={{to: '/tables', label: 'All tables'}} title='Product Group Detail'
                    titleTestId={'ProductGroupDetailsPageTitle'}/>
            <Page>
                <TableWrapper>
                    <Table
                        rowData={data?.data}
                        ref={gridRef}
                        height={'100%'}
                        returnedRecords={data?.data?.length}
                        columnDefs={[
                            {minWidth: 100, field: 'productGroupId', headerName: 'Product Group No.'},
                            {minWidth: 100, field: 'classId', headerName: 'Class No.'},
                            {minWidth: 100, field: 'baseId', headerName: 'Base No.'},
                            {minWidth: 100, field: 'productId', headerName: 'Product No.'},
                            {minWidth: 100, field: 'toppingValue', headerName: 'Topping Value'},
                        ]}
                    />
                </TableWrapper>
            </Page>
        </>
    );
};

export default ProductGroupDetails;
